import clsx from 'clsx';
import { HTMLAttributes } from 'react';
import DotsDarkSvg from '../../assets/dots-dark.svg';
import DotsLightSvg from '../../assets/dots-light.svg';
import PlusSvg from '../../assets/plus.svg';
import { NODE_ENV, ROUTES } from '../../utils/constants';
import { useLocation } from 'react-router';

const HomologIndicator = () =>
  NODE_ENV === 'homolog' ? (
    <p
      className={clsx(
        'absolute top-0 left-0 z-50',
        'm-2 text-error pointer-events-none'
      )}
    >
      homolog
    </p>
  ) : null;

const DOTS_WIDTH = 360;

const DoubleDots = (): JSX.Element => (
  <>
    <img
      className={clsx('absolute top-2/3 left-2/4')}
      src={DotsLightSvg}
      alt=""
      width={DOTS_WIDTH}
    />
    <img
      className={clsx('absolute bottom-2/3 left-3/4')}
      src={DotsLightSvg}
      alt=""
      width={DOTS_WIDTH}
    />
  </>
);

const QuadrupleDots = (): JSX.Element => (
  <>
    {/* top left */}
    <img
      className={clsx('absolute')}
      style={{ top: '10%', left: '10%' }}
      src={DotsLightSvg}
      alt=""
      width={DOTS_WIDTH}
    />
    {/* bottom left */}
    <img
      className={clsx('absolute')}
      style={{ bottom: '-2%', left: '-2%' }}
      src={DotsLightSvg}
      alt=""
      width={DOTS_WIDTH}
    />
    {/* top right */}
    <img
      className={clsx('absolute')}
      style={{ top: '-2%', right: '-2%' }}
      src={DotsDarkSvg}
      alt=""
      width={DOTS_WIDTH}
    />
    {/* bottom right */}
    <img
      className={clsx('absolute')}
      style={{ bottom: '10%', right: '10%' }}
      src={DotsDarkSvg}
      alt=""
      width={DOTS_WIDTH}
    />
  </>
);

const Plus = (): JSX.Element => (
  <div
    className={clsx('absolute inset-0')}
    style={{
      backgroundImage: `url(${PlusSvg})`,
      opacity: 0.2,
    }}
  />
);

const DetailsComponents = {
  'dots-double': DoubleDots,
  'dots-quadruple': QuadrupleDots,
  plus: Plus,
};

type Details = 'dots-double' | 'dots-quadruple' | 'plus' | '';
type Variant = 'bg-gradient-br' | 'bg-gradient-l' | 'bg-gradient-tl';

export type BackgroundProps = HTMLAttributes<HTMLDivElement>;

export const Background = ({
  children,
  className,
  ...props
}: BackgroundProps) => {
  const location = useLocation();

  const detailsOfPath: Record<string, Details> = {
    [ROUTES.home]: 'plus',
    [ROUTES.auth.login]: 'dots-quadruple',
    [ROUTES.users.create]: 'dots-double',
    [ROUTES.auth.newPass]: 'dots-quadruple',
    [ROUTES.auth.resetPass]: 'dots-quadruple',
    [ROUTES.users.me]: 'dots-double',
  };
  const variantOfPath: Record<string, Variant> = {
    [ROUTES.home]: 'bg-gradient-br',
    [ROUTES.auth.login]: 'bg-gradient-br',
    [ROUTES.users.create]: 'bg-gradient-br',
    [ROUTES.auth.newPass]: 'bg-gradient-br',
    [ROUTES.auth.resetPass]: 'bg-gradient-br',
    [ROUTES.users.me]: 'bg-gradient-br',
  };

  const details = detailsOfPath[location.pathname] ?? '';
  const variant = variantOfPath[location.pathname] ?? 'bg-gradient-l';

  const Details = details ? DetailsComponents[details] : () => null;

  return (
    <>
      <div
        {...props}
        className={clsx(
          'fixed inset-0 -z-50 overflow-hidden',
          'pointer-events-none',
          className,
          variant
        )}
      >
        <Details />
      </div>

      <div>{children}</div>

      <HomologIndicator />
    </>
  );
};
